export default "__VITE_ASSET__Cd_7$0nA__"